import React from 'react';

import { Card, CardContent, GlobalStyles } from '@mui/material';

import PropTypes from 'prop-types';

import { COLORS } from '../Constant/COLORS';

const spanStyles = <GlobalStyles styles={{ span: { fontWeight: 500 } }} />;

const CardLayout = ({ children, sx, ...rest }) => (
  <Card
    sx={{
      backgroundColor: COLORS.surface,
      borderRadius: 3,
      ...sx,
    }}
    {...rest}
  >
    <CardContent>
      {spanStyles}
      {children}
    </CardContent>
  </Card>
);

CardLayout.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default CardLayout;
